module.exports = __webpack_public_path__ + "img/plan-bronze.bc173f5a.svg";